var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSyncFromEntities = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.065 3C6.609 3 3 4.79 3 7s3.609 4 8.065 4c.504 0 1.008-.03 1.512-.08V9.5h2.913l-1.008-1L18.02 5c-1.411-1.2-3.992-2-6.955-2m6.975 4.08L16.61 8.5l2.52 2.5h-5.04v2h5.04l-2.52 2.5 1.431 1.42L23 12zM3 9v3c0 2.21 3.609 4 8.065 4 1.179 0 2.278-.15 3.276-.37l1.139-1.13h-2.903v-1.58c-.504.05-1.008.08-1.512.08C6.609 13 3 11.21 3 9m0 5v3c0 2.21 3.609 4 8.065 4 2.963 0 5.544-.8 6.955-2l-1.915-1.9c-1.401.56-3.125.9-5.04.9C6.609 18 3 16.21 3 14"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSyncFromEntities);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sync-from-entities.f04d65c7.svg";